module.exports = __webpack_public_path__ + "img/ch07_02_过闸机.01880724.jpg";